import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=2a2a5019&shadow"
import script from "./NavBar.vue?vue&type=script&lang=js&shadow"
export * from "./NavBar.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports